module.exports = __webpack_public_path__ + "static/img/16.ea65497.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/16.png
// module id = 71/L
// module chunks = 0